module.exports = __webpack_public_path__ + "static/media/icon_select4.da5d6e7f.svg";